import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberCommaToDotFormat'
})
export class NumberCommaToDotFormatPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): number {
    if (value) {
      return parseFloat(value.toString().replace(/\s/g, '').replace(',', '.'));
    }

    return value;
  }

  transformfromString(value: string) : number {
    if (value){
      const newvalue = value.replace(/\s/g, '').replace(',', '.');
      return !isNaN(Number(newvalue)) ? Number(newvalue) : 0;
    }

    return 0;
  }
}
